<template>
  <div
    v-if="visible"
    class="tbi-instalment-hint"
    :class="compact ? 'tbi-instalment-hint--compact' : ''"
  >
    <span class="tbi-logo-wrap" aria-hidden="true">
      <TbiLogo :size="compact ? 'sm' : 'md'" />
    </span>
    <p class="tbi-instalment-hint__text">
      <template v-if="compact">
        de la <strong>{{ formatPrice(monthly) }}</strong>/lună
      </template>
      <template v-else>
        sau de la <strong>{{ formatPrice(monthly) }}</strong>/lună
        <span class="tbi-instalment-hint__meta">· {{ instalments }} rate</span>
      </template>
    </p>
  </div>
</template>

<script setup lang="ts">
import { estimateTbiMonthlyPayment, resolveTbiInstalments, TBI_BRAND_COLOR } from '~/utils/tbiDisplay'

const props = withDefaults(defineProps<{
  amount: number
  /** Shorter line for sticky bars / quick view */
  compact?: boolean
}>(), {
  compact: false,
})

const { paymentMethods } = useSiteSettings()
const { formatPrice } = useSeo()

const instalments = computed(() =>
  resolveTbiInstalments(paymentMethods.value.tbi_default_instalments),
)

const monthly = computed(() =>
  estimateTbiMonthlyPayment(props.amount, instalments.value),
)

const visible = computed(() =>
  paymentMethods.value.tbi && monthly.value > 0,
)
</script>

<style scoped>
.tbi-instalment-hint {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 0.65rem;
  margin-top: 0.5rem;
}

.tbi-instalment-hint--compact {
  margin-top: 0.25rem;
  gap: 0.35rem 0.5rem;
}

.tbi-logo-wrap {
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.45rem;
  border-radius: 0.5rem;
  background: #fff;
  box-shadow: inset 0 0 0 1px rgb(255 102 0 / 0.25);
}

.tbi-instalment-hint__text {
  margin: 0;
  font-size: 0.875rem;
  line-height: 1.35;
  color: var(--ui-text-toned, #4b5563);
}

.tbi-instalment-hint--compact .tbi-instalment-hint__text {
  font-size: 0.75rem;
}

.tbi-instalment-hint__text strong {
  color: v-bind(TBI_BRAND_COLOR);
  font-weight: 700;
}

.tbi-instalment-hint__meta {
  color: var(--ui-text-muted, #9ca3af);
  font-weight: 400;
}
</style>
